import oData from './odataCompat';

import Store from '../script/store';
import Base64  from '../script/base64.js';
import Util from '../script/utils.js';
import * as ofbiz from './ofbiz';

var serviceAddress = Store.get("serviceUrl");
var tokenVerify = Store.get("tokenUrl");

// 迁移辅助：无新接口时不调旧 /bods.svc/，直接回调空数据
// （避免旧接口下线后返回 "token invalid." 误判登录失效）
function degrade(callback, data) {
  callback && callback(data);
}

// const serviceInfo = {
//   "serviceAddress": "http://demo.itoss.com.cn/bods.svc/",
//   "tokenVerify": "http://demo.itoss.com.cn/rest/auth/login",
//   "servletServiceAddress": "http://demo.itoss.com.cn/"
// };

class odata_client {

  constructor(){
    if (serviceAddress) {
      this.setOdataConfig();
    }
  }

  setOdataConfig() {
    console.log(Store.get("serviceUrl"), Store.get('token'));
    // text/plain, application/json
    oData().config({
      endpoint: Store.get("serviceUrl"),
      //  //zs 做了代理
      //  endpoint:'/bods.svc/',
      // format: 'json', // The media format. Default is JSON.
      autoFormat: false,
      version: 4,
      headers: [
        // { name: 'Referer', value: location.origin + location.pathname},
        // { name: 'Content-Type', value: 'application/json' },
        // { name: 'Accept', value: 'application/json' },
      ],
      isAsync: true,
      appending: [{name: 'token', value: Store.get('token')}],
      // isWithCredentials: true,
      // isCors: true
    });
  }

  //登录
  getToken(user, callback){
    Store.getConfigJson((data) => {
      Store.set("serviceUrl", data.ServiceAddress);
			Store.set("tokenUrl", data.TokenVerify);
			Store.set("platformType", data.platformType);
			Store.set("servletServiceUrl", data.ServletServiceAddress);
			Store.set("newsamUrl", data.newsamUrl);
			Store.set("localUserName", user.username);
      Store.set("itossUrl", data.ServiceItoss);
      Store.set("mapUrl", data.mapUrl);
      Store.set("wsUrl", data.wsUrl);
      Store.set("dashboardUrl", data.dashboardUrl);
      Store.set("vlanUrl", data.vlanUrl);
      Store.set("mobileUrl", data.mobileUrl);
			$.ajax({
				type: "get",
				async: true,
				url: data.TokenVerify,
				dataType: "json",
				cache:false,
				data: {
					user: user.username,
					passwd: user.password
				},
				success: function (data) {
          if(data.token){
            Store.set("token", data.token);
          }
          ODataClient.setOdataConfig();
					if(data.result === "ok" && data.multi_roles === "0") {
						Store.set("CURRENT_ROLENAME", data.roles);
            // ODataClient.getUserInfo(user.username, function(res){
            //   callback(Object.assign({}, data, res));
            // });
            callback(data);
					}else{
						callback(data);
					}
				},
				timeout: 30000,
				error: function (data) {
					callback({result: 'error'});
				}
			});
    });
    // // 打包用 path.json, 本地运行可用 path_local.json
    // // $.getJSON("path.json",function(data){
    // // $.getJSON("path6.3.json",function(data){
    // // $.getJSON("path6.16.json",function(data){
    // // $.getJSON("path9.18.json",function(data){
    // $.getJSON("path_ecc.json",function(data){
    // // $.getJSON("path_local.json",function(data){
		// 	Store.set("serviceUrl", data.ServiceAddress);
		// 	Store.set("tokenUrl", data.TokenVerify);
		// 	Store.set("platformType", data.platformType);
		// 	Store.set("servletServiceUrl", data.ServletServiceAddress);
		// 	Store.set("newsamUrl", data.newsamUrl);
		// 	Store.set("localUserName", user.username);
    //   Store.set("itossUrl", data.ServiceItoss);
    //   Store.set("mapUrl", data.mapUrl);
    //   Store.set("wsUrl", data.wsUrl);
		// 	$.ajax({
		// 		type: "get",
		// 		async: false,
		// 		url: data.TokenVerify,
		// 		dataType: "json",
		// 		cache:false,
		// 		data: {
		// 			user: user.username,
		// 			passwd: user.password
		// 		},
		// 		success: function (data) {
    //       if(data.token){
    //         Store.set("token", data.token);
    //       }
    //       ODataClient.setOdataConfig();
		// 			if(data.result === "ok" && data.multi_roles === "0") {
		// 				Store.set("CURRENT_ROLENAME", data.roles);
    //         // ODataClient.getUserInfo(user.username, function(res){
    //         //   callback(Object.assign({}, data, res));
    //         // });
    //         callback(data);
		// 			}else{
		// 				callback(data);
		// 			}
		// 		},
		// 		timeout: 30000,
		// 		error: function (data) {
		// 			callback({result: 'error'});
		// 		}
		// 	});
		// });
  }

  getUserInfo(userName, callback){
    oData('GetUserInfo').get(function(data) {
      callback(data);
    }, function(status) {
      console.error(status);
      callback(status);
    });
  }

  getVersion(callback) {
    var servletService = Store.get("servletServiceUrl");
    var rquestUri = servletService + "GetLastVersion";
    $.ajax({
      type: "get",
      async: true,
      url: rquestUri,
      dataType: "json",
      cache: false,
      success: function(result) {
        callback(result)
      },
      error: function(result) {
        callback(result.status == 200?result.responseText:"");
      }
    });
  }

  //获取资源树数据
  getDeviceMonitorTree(filter, callback, errorCallback){
    if (filter && filter.hasOwnProperty('startTime') && filter.startTime && filter.hasOwnProperty('endTime') && filter.endTime) {
      let filters = "LastModDateTime gt '" + filter.startTime + "' and LastModDateTime lt '" + filter.endTime + "'";
      let expands = "GroupEquipment($filter=" + filters + ";$orderby=Sorter,Title asc;$expand=EquipmentMonitor($filter=" + filters + ";$orderby=Sorter,Title asc))";
      oData('EccGroup').filter(filters).orderBy('Sorter,GroupName', 'asc').expand(expands).get(function(data) {
        if (!data || data.errmsg) {
          errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        } else {
          callback && callback(data);
        }
      }, function(status) {
        console.error(status);
        errorCallback && errorCallback(status);
      });
    } else {
      oData('EccGroup').orderBy('Sorter,GroupName', 'asc').expand('GroupEquipment($orderby=Sorter,Title asc;$expand=EquipmentMonitor($orderby=Sorter,Title asc))').get(function(data) {
        if (!data || data.errmsg) {
          errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        } else {
          callback && callback(data);
        }
      }, function(status) {
        console.error(status);
        errorCallback && errorCallback(status);
      });
    }
  }

  //获取所有资源及其监测器 （根据时间范围）
  getAllEquipmentAndMonitor(filter, callback, errorCallback){
    if (filter && filter.hasOwnProperty('startTime') && filter.hasOwnProperty('endTime')) {
      let filters = "LastModDateTime gt '" + filter.startTime + "' and LastModDateTime lt '" + filter.endTime + "'";
      oData("GroupEquipment").filter(filters).orderBy("Sorter,Title", "asc").expand("EquipmentMonitor($filter=" + filters + ";$orderby=Sorter,Title asc)").get(function(data){
        if (!data || data.errmsg) {
          errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        } else {
          callback && callback(data);
        }
      }, function(status) {
        console.error(status);
        errorCallback && errorCallback(status);
      });
    } else {
      oData("GroupEquipment").orderBy("Sorter,Title", "asc").expand("EquipmentMonitor($orderby=Sorter,Title asc)").get(function(data){
        if (!data || data.errmsg) {
          errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        } else {
          callback && callback(data);
        }
      }, function(status) {
        console.error(status);
        errorCallback && errorCallback(status);
      });
    }
  }

  //获取所有资源
  getAllEquipments(callback, errorCallback) {
    oData('GroupEquipment').select("RecId,Title,ServerAddress").get(function(data){
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
      } else {
        callback && callback(data);
      }
    }, function(status){
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //获取检测器总数
  getMonitorCount(callback, errorCallback) {
    // === 已切换到 OFBiz 新接口 /monitor/stateStatistics ===
    ofbiz.getMonitorStateStatistics().then(
      (data) => callback && callback(data),
      (err) => errorCallback && errorCallback({ errorCode: 1, errmsg: '' }),
    );
  }

  //获取EccMonitorList
  getEccMonitorList(callback, errorCallback) {
    oData('EccMonitorList').select("MonitorName,MonitorTableName").orderBy("MonitorName", "asc").get(function(data){
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
      } else {
        callback && callback(data);
      }
    }, function(status){
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //获取告警规则列表
  getAlarmRuleList(callback, errorCallback) {
    oData('AlarmConfig').get(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //获取报警事件
  getAlarmEvent(params, callback, errorCallback) {
    // 降级：消费方（deviceMonitor_action.receiveGetAlarmEvent）依赖旧 OData
    // eval 字符串结构（EVENTDATA/COUNT），与新接口 alarmEvent/list 的 JSON
    // 结构完全不兼容。返回空 results 让消费方走 setRequestFail 分支。
    // 注：告警事件列表已在 rest_client.getAlarmEvent 单独对接 alarmEvent/list。
    degrade(callback, { results: [] });
  }

  //获取报警事件日志
  getAlarmEventLogs(params, callback, errorCallback) {
    let eventIds = params.eventIds;
    let filters = "AlarmEventRecId eq ''";
    if (!eventIds) {
      filters = "AlarmEventRecId ne ''";
    } else {
      if (eventIds.length > 0) {
        filters = "(";
        eventIds.forEach((id, index) => {
          filters += (index===0?"":" or ") + "AlarmEventRecId eq '" + id + "'";
        });
        filters += ")";
      }
    }
    let filters_2 = "";
    if (params.startTime && params.endTime) {
      filters_2 += (filters_2===""?" and (":" and ") + "LastModDateTime ge '" + params.startTime + "' and LastModDateTime le '" + params.endTime + "'";
    }
    if(params.MonitorStatus) { //报警级别
      if (params.MonitorStatus instanceof Array) {
        params.MonitorStatus.forEach((item, index) => {
          if (index === 0) {
            filters_2 += (filters_2===""?" and (":" and ") + "(MonitorStatus eq '" + item + "'";
          } else {
            filters_2 += " or MonitorStatus eq '" + item + "')";
          }
        });
      } else {
        filters_2 += (filters_2===""?" and (":" and ") + "MonitorStatus eq '" + params.MonitorStatus + "'";
      }
    }
    if (params.AlarmStatus) { //报警状态
      filters_2 += (filters_2===""?" and (":" and ") + "AlarmStatus eq '" + params.AlarmStatus + "'";
     }
    if (params.EquipmentRecId) {
      filters_2 += (filters_2===""?" and (":" and ") +  "EquipmentRecId eq '" + params.EquipmentRecId + "'";
    }
    if (params.MonitorType) {
      filters_2 += (filters_2===""?" and (":" and ") + "MonitorType eq '" + params.MonitorType + "'";
    }
    if (filters_2) {
      filters_2 += ")";
    }
    oData('AlarmEventLog').filter(filters + filters_2).orderBy("LastModDateTime", "desc").get(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
       callback && callback(data);
     }, function(status) {
       console.error(status);
       errorCallback && errorCallback(status);
     });
   }

   //报警事件日志表中  继续、暂停告警
   startOrStopAlarmEvent(params, callback, errorCallback) {
     oData("AlarmEventLog('" + params.RecId + "')").patch({AlarmStatus: params.opt}).save(function(data) {
       if (!data || data.errmsg) {
         errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
         return;
       }
       callback && callback(data);
     }, function(status) {
       console.error(status);
       errorCallback && errorCallback({errorCode: 1, errmsg: ''});
     });
   }

  getEccGroup(callback, errorCallback){
    // === 已切换到 OFBiz 新接口 /equipmentGroup/list ===
    ofbiz.getGroupList().then(
      (data) => {
        const list = Array.isArray(data) ? data : ((data && data.list) || []);
        callback && callback(list);
      },
      (err) => errorCallback && errorCallback({ errorCode: 1, errmsg: '' }),
    );
  }

  getEccGroupById(id, callback, errorCallback) {
    oData('EccGroup').search(['RecId'], id).get(function(data) {
      callback && callback({results: data});
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  createEccGroup(dateObjec,callback, errorCallback) {
    oData('EccGroup').post(dateObjec).save(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  // 修改组，启用组(Status=disabled)，禁用组(Status=good)
  updateEccGroup(dateObjec, callback, errorCallback) {
    oData("EccGroup('" + dateObjec.RecId + "')").patch(dateObjec).save(function(data) {
      callback && callback({results: data});
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  // 删除组，及组下面关联的子组，资源
  deleteEccGroup(recid,callback, errorCallback) {
    oData("EccGroup('" + recid + "')").remove().save(function(data) {
      if (data && data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback({results: data});
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  // 修改资源，启用资源(EquipmentStatus=disabled)，禁用资源(EquipmentStatus=good)
  updateEquipment(dateObjec, callback, errorCallback) {
    oData("Equipment('" + dateObjec.RecId + "')").patch(dateObjec).save(function(data) {
      // callback && callback({results: data});
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
      } else {
        callback && callback({results: data});
      }
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  // 删除资源
  deleteEquipment(recid,callback, errorCallback) {
    oData("Equipment('" + recid + "')").remove().save(function(data) {
      if (data && data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback({results: data});
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  // 修改监测器，启用监测器(IsDisable=true)，禁用监测器(IsDisable=false)
  updateMonitor(dateObjec, callback, errorCallback) {
    oData("Monitor('" + dateObjec.RecId + "')").patch(dateObjec).save(function(data) {
      // callback && callback({results: data});
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
      } else {
        callback && callback({results: data});
      }
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  // 删除监测器
  deleteMonitor(recid,callback, errorCallback) {
    // === 已切换到 OFBiz 新接口 /monitor/delete ===
    ofbiz.deleteMonitor(recid).then(
      (data) => callback && callback({ results: data }),
      (err) => errorCallback && errorCallback({ errorCode: 1, errmsg: '' }),
    );
  }

  // 删除监测器告警条件
  deleteMonitorAlarmCondition(recid,callback, errorCallback) {
    // 降级：实例级告警条件无对应查询/删除接口（OFBiz 架构阈值存 FixedAssetAttribute，
    // 见交接文档 4.2）。监测器删除时后端会级联清理，此处不调旧接口。
    degrade(callback, { results: null });
  }

  // 根据MonitorId获取监测器告警条件
  getMonitorAlarmCondition(monitorId, callback, errorCallback) {
    // 降级：实例级阈值/告警条件查询无新接口（交接文档 4.2）。
    // 返回空数组，消费方 data.length==0 跳过清理逻辑。
    degrade(callback, []);
  }

  // 获取子组
  getChildrenGroups(pid, callback, errorCallback) {
    // === 已切换到 OFBiz 新接口 /equipmentGroup/list ===
    ofbiz.getGroupList().then(
      (data) => {
        const all = Array.isArray(data) ? data : ((data && data.list) || []);
        // 按 parentGroupId 过滤，兼容 groupId/parentGroupId 字段
        const list = all.filter(item => String(item.parentGroupId || item.ParentGroupId) === String(pid));
        callback && callback({ results: list });
      },
      (err) => errorCallback && errorCallback({ errorCode: 1, errmsg: '' }),
    );
  }

  // 获取组下资源
  getChildrenEquips(id, callback, errorCallback) {
    // === 已切换到 OFBiz 新接口 /equipment/list ===
    ofbiz.getEquipmentList({ parentFixedAssetId: id }, 1, 10000).then(
      (res) => {
        const list = (res && res.list) || [];
        callback && callback({ results: list });
      },
      (err) => errorCallback && errorCallback({ errorCode: 1, errmsg: '' }),
    );
  }

  //获取监测器阀值
  getThresholdList(ids, callback, errorCallback) {
    console.log(ids)
    // 国际化
    let filters = "MonitorId ne ''";
    if (ids.length > 0) {
      filters = "";
      ids.forEach((id, index) => {
        filters += (index===0?"":" or ") + "MonitorId eq '" + id + "'";
      });
    }
    oData('alarms').filter(filters).get(function(data){
      callback && callback(data);
    }, function(status){
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //获取监测器日志
  getMonitorLogs(filters, callback, errorCallback) {
    let filter = "MonitorId eq '" + filters.MonitorId + "' and LogTime lt '" + filters.endTime + "' and LogTime gt '" + filters.startTime + "'";
    oData("monitorlogs").filter(filter).orderBy("LogTime").get(function(data){
      // console.log("monitorlogs:", data);
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    },function(status){
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //获取私有用户
  getPrivateUser(callback, errorCallback) {
    // 降级：微信/数据通讯私有用户无 OFBiz 对应接口
    degrade(callback, null);
  }

  //获取邮件服务器设置数据
  getEmailServerConfig(callback, errorCallback) {
    oData("EccMail").first().get(function(data){
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    },function(status){
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //获取短信发送设置数据
  getSMSServerConfig(callback, errorCallback) {
    oData("EccSMS").first().get(function(data){
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    },function(status){
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //获取邮箱和短信模板数据
  getMailAndSMSTemplate(callback, errorCallback) {
    oData("EccMailModle").get(function(data){
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    },function(status){
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //添加邮箱或短信模板
  createTemplate(params, callback, errorCallback) {
    oData("EccMailModle").post(params).save(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //更新邮箱或短信模板
  updateTemplate(params, callback, errorCallback) {
    oData("EccMailModle('" + params.RecId + "')").patch(params).save(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //删除邮箱或短信模板
  deleteTemplate(RecId, callback, errorCallback){
    oData("EccMailModle('" + RecId + "')").remove().save(function(data) {
      if (data && data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //更新邮箱服务器设置
  updateEmailServerConfig(params, callback, errorCallback) {
    if (params.RecId) {
      oData("EccMail('" + params.RecId + "')").patch(params).save(function(data) {
        if (!data || data.errmsg) {
          errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
          return;
        }
        callback && callback(data);
      }, function(status) {
        console.error(status);
        errorCallback && errorCallback(status);
      });
    } else {
      oData("EccMail").post(params).save(function(data) {
        if (!data || data.errmsg) {
          errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
          return;
        }
        callback && callback(data);
      }, function(status) {
        console.error(status);
        errorCallback && errorCallback(status);
      });
    }
  }

  //更新短信发送设置
  updateSMSServerConfig(params, callback, errorCallback) {
    if (params.RecId) {
      oData("EccSMS('" + params.RecId + "')").patch(params).save(function(data) {
        if (!data || data.errmsg) {
          errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
          return;
        }
        callback && callback(data);
      }, function(status) {
        console.error(status);
        errorCallback && errorCallback(status);
      });
    } else {
      oData("EccSMS").post(params).save(function(data) {
        if (!data || data.errmsg) {
          errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
          return;
        }
        callback && callback(data);
      }, function(status) {
        console.error(status);
        errorCallback && errorCallback(status);
      });
    }
  }

  //新增报警规则
  createAlarmRule(params, callback, errorCallback) {
    oData("AlarmConfig").post(params.alarmRule).save(function(data){
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //更新报警规则
  updateAlarmRule(params, callback, errorCallback) {
    oData("AlarmConfig('" + params.alarmRule.RecId + "')").patch(params.alarmRule).save(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //根据报警规则RecId查询对应设备
  getEquipmentByAlarmConfigRecId(RecId, callback, errorCallback) {
    oData("GroupEquipment").filter("AlarmConfig eq '" + RecId + "'").get(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //修改设备关联的报警规则RecId
  updateEquipmentAlarmConfigRecId(params, callback, errorCallback) {
    oData("GroupEquipment('" + params.RecId + "')").patch({AlarmConfig: params.AlarmConfigRecId}).save(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //删除报警规则
  deleteAlarmRule(RecId, callback, errorCallback) {
    oData("AlarmConfig('" + RecId + "')").remove().save(function(data) {
      if (data && data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //获取值班列表数据
  getDutyData(callback, errorCallback) {
    oData("EccDutyTable").get(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //启动和禁止报警规则
  startOrStopAlarmRule(params, callback, errorCallback) {
    oData("AlarmConfig('" + params.RecId + "')").patch(params).save(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //获取用户数据  (缺少邮箱和电话信息...  有邮箱和电话信息的接口在rest_client.js里面)
  getProfileData(callback, errorCallback) {
    oData("Profile").get(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //获取指定报警规则的用户
  getUserAlarmStaff(ids, callback, errorCallback) {
    let filters = "AlarmConfigRecId ne ''";
    if (ids.length > 0) {
      filters = "";
      ids.forEach((id, index) => {
        filters += (index===0?"":" or ") + "AlarmConfigRecId eq '" + id + "'";
      });
    }
    oData("AlarmStaff").filter(filters).get(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //添加接收人或升级接收人
  addUserAlarmStaff(params, callback, errorCallback) {
    oData("AlarmStaff").post(params).save(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //删除接收人或升级接收人
  deleteUserAlarmStaff(RecId, callback, errorCallback) {
    oData("AlarmStaff('" + RecId + "')").remove().save(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //更新接收人或升级接收人
  updateUserAlarmStaff(params, callback, errorCallback) {
    oData("AlarmStaff('" + params.RecId + "')").patch(params).save(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //获取报警日志
  getAlarmLogs(params, callback, errorCallback){
    let filters = "AlarmTime ge '" + params.startTime + "' and AlarmTime le '" + params.endTime + "'";
    if (params.EquipmentId) {
      filters += " and EquipmentId eq '" + params.EquipmentId + "'";
    }
    if (params.AlarmName) {
      filters += " and AlarmName eq '" + params.AlarmName + "'";
    }
    oData("AlarmLog").filter(filters).get(function(data){
      callback && callback(data);
    }, function(status){
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //获取群组数据
  getOrganizationData(callback, errorCallback) {
    oData('Organization').get(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //获取区域数据
  getAreaData(callback, errorCallback) {
    oData('Area').get(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //获取单位数据
  getUnitData(callback, errorCallback) {
    oData('Unit').get(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //获取部门数据
  getDepartmentData(callback, errorCallback) {
    oData('Department').get(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //获取指定部门的职位数据
  getDepartmentJobData(name, callback, errorCallback) {
    let filters = "DepartmentName eq '" + name + "'";
    oData("Jobtitle").filter(filters).get(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //根据组织名称获取组织数据
  getOrganizationByName(organizationName, callback, errorCallback) {
    // 降级：新架构仅 org 单树 + safeGroup，无 Organization/Area/Unit 多级模型
    // （交接文档第 5 节）。返回空数组。
    degrade(callback, []);
  }

  //修改组织的父组织编码
  setOrganizationParent(params, callback, errorCallback) {
    // 降级：同上，组织多级模型无对应接口
    degrade(callback, []);
  }

  //获取巡检错误报表
  getCheckErrorReport(callback, errorCallback) {
    oData("ErrorReports").get(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //获取巡检统计报表
  getCheckStatisticsReport(callback, errorCallback) {
    oData("StatisticsReports").get(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //获取TopN报表
  getTopNReport(callback, errorCallback) {
    oData("TopNReports").get(function(data) {
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback(status);
    });
  }

  //添加巡检错误报表
  addCheckErrorReport(params, callback, errorCallback) {
    oData("ErrorReports").post(params).save(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //添加巡检统计报表
  addCheckStatisticsReport(params, callback, errorCallback) {
    oData("StatisticsReports").post(params).save(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //添加TopN报表
  addTopNReport(params, callback, errorCallback) {
    oData("TopNReports").post(params).save(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //更新巡检错误报表
  updateCheckErrorReport(params, callback, errorCallback) {
    oData("ErrorReports('" + params.RecId + "')").patch(params).save(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //更新巡检统计报表
  updateCheckStatisticsReport(params, callback, errorCallback) {
    oData("StatisticsReports('" + params.RecId + "')").patch(params).save(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //更新TopN报表
  updateTopNReport(params, callback, errorCallback) {
    oData("TopNReports('" + params.RecId + "')").patch(params).save(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //删除巡检错误报表
  deleteCheckErrorReport(RecId, callback, errorCallback) {
    oData("ErrorReports('" + RecId + "')").remove().save(function(data) {
      if (data && data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //删除巡检统计报表
  deleteCheckStatisticsReport(RecId, callback, errorCallback) {
    oData("StatisticsReports('" + RecId + "')").remove().save(function(data) {
      if (data && data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //删除TopN报表
  deleteTopNReport(RecId, callback, errorCallback) {
    oData("TopNReports('" + RecId + "')").remove().save(function(data) {
      if (data && data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //启动或禁止巡检错误报表
  startOrStopCheckErrorReport(params, callback, errorCallback) {
    oData("ErrorReports('" + params.RecId + "')").patch(params).save(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //启动或禁止巡检统计报表
  startOrStopCheckStatisticsReport(params, callback, errorCallback) {
    oData("StatisticsReports('" + params.RecId + "')").patch(params).save(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //启动或禁止巡检统计报表
  startOrStopTopNReport(params, callback, errorCallback) {
    oData("TopNReports('" + params.RecId + "')").patch(params).save(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //获取报表关联的监测器id
  getReportRelatedMonitorId(reportIds, callback, errorCallback) {
    if (reportIds.length > 0) {
      let filters = '';
      reportIds.forEach((item, index) => {
        filters += (index!=0?' or ':'') + "ReportID eq '" + item + "'";
      });
      oData("ReSelMonitorss").filter(filters).get(function(data){
        callback && callback(data);
      }, function(status){
        errorCallback && errorCallback(status);
      });
    } else {
      errorCallback && errorCallback();
    }
  }

  //添加报表和监测器id的关联
  addReSelMonitors(params, callback, errorCallback) {
    oData("ReSelMonitorss").post(params).save(function(data){
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status) {
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //删除报表和监测器id的关联
  deleteReSelMonitors(RecId, callback, errorCallback) {
    oData("ReSelMonitorss('" + RecId + "')").remove().save(function(data){
      callback && callback(data);
    }, function(status) {
      errorCallback && errorCallback(status);
    });
  }

  //获取报表所关联的文件
  getReportFiles(reportId, callback, errorCallback) {
    oData("ReportFiless").filter( "ReportID eq '" + reportId + "'").orderBy('CreatedDateTime', 'desc').get(function(data){
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status){
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //删除报表所关联的文件
  deleteReportFiles(RecId, callback, errorCallback) {
    oData("ReportFiless('" + RecId + "')").remove().save(function(data){
      if (data && data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
        return;
      }
      callback && callback(data);
    }, function(status){
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //删除资源3D节点
  deleteNetworkNode(monitorId, callback, errorCallback) {
    oData("NetWorkNode").filter( "NodeRelationMonitor eq '" + monitorId + "'").get(function(data){
      let loop = data => {
        oData("NetWorkNode('" + data[0].RecId + "')").remove().save(function(data2) {
          data.splice(0, 1);
          if (data.length > 0) {
            loop(data);
          }
          else {
            callback && callback('success');
          }
        }, function(status) {
          console.error(status);
          errorCallback && errorCallback(status);
        });
      };
      if (data.length > 0) {
        loop(data);
      }
      else {
        callback && callback('success');
      }
    }, function(status){
      errorCallback && errorCallback(status);
    });
  }

  //删除资源3D节点关联关系
  deleteNetworkRelation(monitorId, callback, errorCallback) {
    oData("NetWorkRelation").filter( "FromNode eq '" + monitorId + "' or ToNode eq '" + monitorId + "'").get(function(data){
      let loop = data => {
        oData("NetWorkRelation('" + data[0].RecId + "')").remove().save(function(data2) {
          data.splice(0, 1);
          if (data.length > 0) {
            loop(data);
          }
          else {
            callback && callback('success');
          }
        }, function(status) {
          console.error(status);
          errorCallback && errorCallback(status);
        });
      };
      if (data.length > 0) {
        loop(data);
      }
      else {
        callback && callback('success');
      }
    });
  }

  //获取所有监测器类型指标项
  getMonitorItems(callback, errorCallback) {
    oData("Items").get(function(data){
      callback && callback(data);
    }, function(status){
      errorCallback && errorCallback(status);
    });
  }

  // 获取角色用户关系
  getUserRoles(callback, errorCallback) {
    oData("UserRole").get(function(data){
      if (data && data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
      } else {
        callback && callback(data);
      }
    }, function(status){
      errorCallback && errorCallback(status);
    });
  }

  //添加用户到角色
  createUserRole(params, callback, errorCallback) {
    oData("UserRole").post(params).save(function(data){
      if (data && data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
      } else {
        callback && callback(data);
      }
    }, function(status){
      errorCallback && errorCallback(status);
    });
  }

  //删除角色用户
  deleteUserRole(recId, callback, errorCallback) {
    oData("UserRole('" + recId + "')").remove().save(function(data){
      if (data && data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
      } else {
        callback && callback(data);
      }
    }, function(status){
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  // 批量设置监测器属性 - 测试 batch 方法
  batchSettingMonitorProperty(param, callback, errorCallback) {
    oData("Monitor('" + param.recId + "')").put(param.data).batch("Monitor('" + param.recId2 + "')").put(param.data).save(function(data){
      if (data && data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
      } else {
        callback && callback(data);
      }
    }, function(status){
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  // 获取操作审计数据
  getOperationAuditData(filters, callback, errorCallback) {
    let filter = "CreatedDateTime lt '" + filters.endTime + "' and CreatedDateTime gt '" + filters.startTime + "'";
    if (filters.operationObject) {
      filter += " and BoId eq '" + filters.operationObject + "'";
    }
    if (filters.operationType) {
      filter += " and OperationType eq '" + filters.operationType + "'";
    }
    if (filters.operationResult) {
      const _result = filters.operationResult == '1' ? '成功' : '失败';
      filter += " and (OperationResults eq '" + filters.operationResult + "' or contains(OperationResults, '" + _result + "'))";
    }
    oData("OperationAudit").filter(filter).orderByDesc("CreatedDateTime").get(function(data) {
      if (!data || data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
      } else {
        callback && callback(data);
      }
    }, function(status) {
      console.error(status);
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //添加操作审计记录
  createOperationAudit(params, callback, errorCallback) {
    oData("OperationAudit").post(params).save(function(data){
      if (data && data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
      } else {
        callback && callback(data);
      }
    }, function(status){
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //修改操作审计记录
  updateOperationAudit(dateObjec, callback, errorCallback) {
    oData("OperationAudit('" + dateObjec.RecId + "')").patch(dateObjec).save(function(data) {
      if (data && data.errmsg) {
        errorCallback && errorCallback({errorCode: 1, errmsg: data ? data.errmsg : ''});
      } else {
        callback && callback(data);
      }
    }, function(status) {
      errorCallback && errorCallback({errorCode: 1, errmsg: ''});
    });
  }

  //获取图标资源数据
  getImageResource(callback, errorCallback) {
    // 降级：资源图标库无 OFBiz 接口（已改用本地静态图标，交接文档第 5 节）
    degrade(callback, []);
  }

  //添加图标资源
  addImageResource(params, callback, errorCallback) {
    // 降级：资源图标库无 OFBiz 接口。走错误回调让消费方提示失败。
    errorCallback && errorCallback({ errorCode: 1, errmsg: '资源图标库接口暂未对接' });
  }

  //更新图标资源
  updateImageResource(params, callback, errorCallback) {
    // 降级：资源图标库无 OFBiz 接口。走错误回调让消费方提示失败。
    errorCallback && errorCallback({ errorCode: 1, errmsg: '资源图标库接口暂未对接' });
  }

  //删除图标资源
  deleteImageResource(RecId, callback, errorCallback){
    // 降级：资源图标库无 OFBiz 接口。走错误回调让消费方提示失败。
    errorCallback && errorCallback({ errorCode: 1, errmsg: '资源图标库接口暂未对接' });
  }

  //获取自动调度表数据
  getAutoTaskSchedulerData(autotaskName, callback, errorCallback) {
    // 降级：任务计划自定义排程无对应接口（交接文档 4.2，表单写死 7*24/5*8）
    degrade(callback, []);
  }

}

const ODataClient = new odata_client();
export default ODataClient;
